export default "__VITE_ASSET__CcI1kkTO__"